<template id="app">
  <router-view v-if="isRouterAlive" />
</template>
<script>
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  }
}

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/App.vue